import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

import SingleData from '../singledata/singledata.component'

import useStyles from './packout-chart.styles'

const PackOutChart = ({ currentLot, ...props }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography className={classes.lotText} color="primary" component="h5" variant="h5">
            {`${t('lot')}#${currentLot.lot_name}`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SingleData title={t('variety')} value={currentLot.variety} />
        </Grid>
        <Grid item xs={12}>
          <SingleData title={t('grower')} value={props.grower} />
        </Grid>
        <Grid item xs={12}>
          <SingleData title={t('firmness')} value={props.averageFirmness} />
        </Grid>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t('select_the_variety_of_the_lot')}</DialogTitle>
        <DialogContent>
          <form>
            <FormControl fullWidth>
              <InputLabel id="demo-dialog-select-label">{t('variety')}</InputLabel>
              <Select labelId="demo-dialog-select-label" id="demo-dialog-select" input={<Input />}>
                <MenuItem value={10}>{t('sweetheart')}</MenuItem>
                <MenuItem value={20}>{t('bing')}</MenuItem>
                <MenuItem value={30}>{t('rainier')}</MenuItem>
              </Select>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('cancel')}
          </Button>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('ok')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => ({
  currentLot: state.lots.currentLot,
})

export default connect(mapStateToProps)(PackOutChart)
